import { render, staticRenderFns } from "./consignee.vue?vue&type=template&id=3832fcd6&scoped=true&"
import script from "./consignee.vue?vue&type=script&lang=ts&"
export * from "./consignee.vue?vue&type=script&lang=ts&"
import style0 from "./consignee.vue?vue&type=style&index=0&id=3832fcd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3832fcd6",
  null
  
)

export default component.exports